<style scoped>
/*fixes for visible select labels in form-element*/
.form-element label{
  font-size:unset;
}
/*fix chevron position since label is visible*/
.form-element .chevron-down{
  top:55%
}
/*remove gray color from drow downs*/
.form-element select {
  color:unset;
}
</style>
<template>
  <div class="max-width-md u-mrg-center">
    <div>
      <div v-show="!isCreated" class="u-txt-center">
        <h2 class="h-lg u-mrg-btm-half" v-html="editAccountTitle"></h2>
        <div class="u-mrg-btm-half" v-html="editAccountSubhead"></div>
        <div v-html="editAccountContent"></div>
      </div>
      <div v-show="!isCreated" class="max-width-sm u-mrg-center u-mrg-top-half u-mrg-btm-2x">
        <div class="u-mrg-btm-half">
          <label v-bind:for="'firstname' + uniqueId" class="">
            <strong>First name</strong>
          </label>
          <input type="text" name="firstname" v-bind:id="'firstname' + uniqueId" class="input"
            v-model="model.FirstName" />
          <div class="error u-padd-btm-none" v-show="submitted && !model.FirstName">
            <strong>Please enter your name.</strong>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <label v-bind:for="'lastname' + uniqueId" class="">
            <strong>Last name</strong>
          </label>
          <input type="text" name="lastname" v-bind:id="'lastname' + uniqueId" class="input" 
            v-model="model.LastName" />
          <div class="error u-padd-btm-none" v-show="submitted && !model.LastName">
            <strong>Please enter your name.</strong>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <label v-bind:for="'phone' + uniqueId" class="">
            <strong>Phone</strong>
          </label>
          <input ref="phoneInput" name="phone" :id="'phone' + uniqueId" placeholder="Phone*"
          v-model="model.Phone" class="input" v-mask="'+1 (###) ###-####'" @input="changePhone" type="tel" />
          <div class="error u-padd-btm-none" v-show="submitted && !model.Phone">
            <strong>Please enter your phone number.</strong>
          </div>
          <div class="error u-padd-btm-none" v-show="submitted && invalidPhone">
            <strong>Please enter a valid phone number.</strong>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <div class="form-element form-element__select">

            <label v-bind:for="'country' + uniqueId" class="">Country</label>
            <select autocomplete="country" class="select country-select" name="country"
              v-bind:id="'country' + uniqueId" v-model="selectedCountry"
              :class="{ error: selectedCountry === '' && submitted }" required>
              <option value=""></option>
              <option v-for="(item, index) in countries" :value="item" v-html="item" :key="`country_${index}`"></option>
            </select>

            <div class="chevron-down"></div>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <div class="form-element form-element__select" v-if="selectedCountry">

            <label v-bind:for="'state' + uniqueId" class="">{{ selectedCountry=="United States" ? "State" : "Province" }}</label>
            <select autocomplete="address-level1" class="select state-select" name="state" v-model="selectedState"
              v-bind:id="'state' + uniqueId" :class="{ error: selectedState === '' && submitted }" required>
              <option value=""></option>
              <option :key="`state_${index}`" v-for="(item, index) in filteredStates" :value="item" v-html="item"></option>
            </select>

            <div class="chevron-down"></div>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <div v-if="canSelectCounty" class="form-element form-element__select ">
            <label v-bind:for="'county' + uniqueId" class="">County</label>

            <select autocomplete="address-level2" class="select county-select" :class="{ error: selectedCounty === '' && submitted }"
              v-model="selectedCounty" name="county" v-bind:id="'county' + uniqueId"
              required>
              <option value="" disabled></option>
              <option v-for="(item, index) in filteredCounties" :key="`county_${index}`" :value="item" v-html="item"></option>
            </select>

            <div class="chevron-down"></div>
          </div>
        </div>
        <div class="u-mrg-btm-half" v-if="invalidGeography">
          <strong v-if="selectedCountry=='United States'" class="error">Please select your country, state, and county</strong>
          <strong v-else class="error">Please select your country and province</strong>
        </div>
        <div class="u-mrg-btm-half">
          <label v-bind:for="'company' + uniqueId" class="">
            <strong>Company</strong>
          </label>
          <input type="text" name="company" v-bind:id="'company' + uniqueId" class="input" 
            v-model="model.Company" />
          <div class="error u-padd-btm-none" v-show="submitted && !model.Company">
            <strong>Please enter company.</strong>
          </div>
        </div>
        <div class="u-mrg-btm-half">
          <div class="form-element form-element__select">
            <label class="" v-bind:for="'customerType' + uniqueId">Customer Type</label>
            <select class="select" v-bind:id="'customerType' + uniqueId" name="customerType" required
              v-model="model.Customer_Type">
              <option id="customerType1x" disabled selected value=""></option>
              <option v-for="(type, index) in customerTypes" :key="`type_${index}`" :value="type">
                {{ type }}
              </option>
            </select>
            <div class="chevron-down"></div>
          </div>
          <div class="error u-padd-btm-none" v-show="submitted && !model.Customer_Type">
            <strong>Please select a customer type.</strong>
          </div>
        </div>
       
        <div class="">  
          <button class="btn btn--blue btn--wide u-mrg-top-half u-display-block"
            data-action="submit" @click.prevent="saveAccount" v-html="editAccountCta"></button>
        </div>

        <div>
          {{ JSON.stringify(model) }}
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { findUniqueValuesIn } from "../../utils/common.js";
import CSCLookup from "../../utils/csc-lookup.js";
import { getRandomId } from "../../utils/random.js";

const saveEditUrl = "/site-api/account/saveedit";
const getEditUrl = "/site-api/account/getedit";

function isValidPhoneNumber(phoneNumber) {
    const regex = /^\+1 \(\d{3}\) \d{3}-\d{4}$/;
    return regex.test(phoneNumber);
}

export default {
  components:{
  },
  props: {
    editAccountTitle: String,
    editAccountSubhead: String,
    editAccountContent: String,
    editAccountCta: String,
    customerTypes: Array,
    dataUrl: String,
    finishUrl: String,

    isModal: {
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {
      success: false,
      error: "",
      userData: {},
      submitted: false,
      saving: false,
      selectedCountry: "",
      selectedState: "",
      selectedCounty: "",
      isCreated: false,
      countries: [],
      states: [],
      counties: [],
      provinces: [],
      invalidGeography: false,
      invalidPhone: false, //todo: do validation for this??
      responseLocations: [],
      lookups: {},
      uniqueId:"ukn",
      model: {}
    };
  },

  methods: {
    changePhone:function(e){
      //handle native browser autofil
      this.model.Phone = e.target.value;
    },
    saveAccount() {
      this.submitted = true;
      if(this.isValid()){
        //mark the button disabled and submit to endpoint
        this.saving=true;
        axios
        .post(`${window.APIDEF.base}${window.APIDEF.account}/saveedit`, this.model, {
          headers: { 'Content-Type': 'application/JSON' },
        })
        .then(response => {

          if (response.data.success) {
            this.saving=false;
            this.submitted=false;
            console.log('saved!');
          }else{
            console.log(`soft save error: ${response.data.errorMessage}`)
          }
        })
        .catch(err=>{
          console.log(`server error: ${err}`);
        });

        console.log("Save model:", this.model);
      }
      
    },
    isValid() {
      let valid = true;
      console.log(this.customerType);
      if (
        !this.model.FirstName ||
        !this.model.LastName  ||
        !this.model.Company   ||
        !this.model.State     ||
        !this.model.Country   ||
        !this.model.Phone     ||
        !this.model.Customer_Type 
      ) {
        valid = false;
      }
  
      //do we have all the selected values for geography?
      if (this.model.Country !== 'Canada' && !this.model.County) {
        valid = false;
        this.invalidGeography=true;
      } else {
        this.invalidGeography=false;
      } // allow canada to pass through

      if(!isValidPhoneNumber(this.model.Phone)){
        valid=false;
        this.invalidPhone=true;
      } else{
        this.invalidPhone=false;
      }
      

      return valid;
    },
    setGeographyModel() {
      this.model.County = this.selectedCounty;
      this.model.Country = this.selectedCountry;
      this.model.State = this.selectedState;
      
      //clear any select errors for the next time you try to validate
      this.invalidGeography=false;
    }
  },
  watch: {
    createFirstName(newVal, oldVal) { },
    selectedCountry: function(newVal, oldVal){
      //when changing country, if the current selected state isn't available
      //under that country, clear it out
      if (!this.filteredStates.includes(this.selectedState)) {
          this.selectedState = "";
      }
      this.setGeographyModel();
    },
    selectedState: function(newVal, oldVal){
      //when selecting state, if the current selected county isn't available under the new state
      //clear it out
      if(!this.filteredCounties.includes(this.selectedCounty)) {
        this.selectedCounty = "";
      }
      this.setGeographyModel();
    },
    selectedCounty: function(newVal, oldVal){
      this.setGeographyModel();
    }
  },
  computed: {
    canSelectCounty() {
      if (this.selectedCountry === "Canada") {
        return false;
      } else {
        if (this.selectedState !== "") {
          return true;
        }
      }
    },
    filteredStates(){
      if(this.selectedCountry){
        return this.lookups.getTerritoriesByCountry(this.selectedCountry);
      }
      return [];
    },
    filteredCounties(){
      if(this.selectedState && this.selectedCountry){
        return this.lookups.getCountiesByTerritory(this.selectedCountry, this.selectedState);
      }
      return [];
    }
  },
  mounted() {
    window.dataLayer = window.dataLayer || [];
   
    this.countries = new Set();
    this.states = new Set();
    this.counties = new Set();
    this.provinces = new Set();

    this.$nextTick(() => {
      axios.get(`${this.$props.dataUrl}`).then((response) => {
        this.responseData = response.data;
        let tmpCountries = [];
        let tmpLocations = [];
        this.responseData.forEach((element, index) => {
          tmpLocations.push(element);
          element.Locations.forEach((location, index) => {
            tmpCountries.push(location);
          });
        });

        this.lookups = new CSCLookup(tmpLocations);

        this.countries = findUniqueValuesIn(tmpCountries, "Country");
        this.countries = this.countries.sort((a, b) => {
          let nameA = a.toUpperCase(); // ignore upper and lowercase
          let nameB = b.toUpperCase(); // ignore upper and lowercase
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        });

        //get current account info to edit
        axios
        .get(`${window.APIDEF.base}${window.APIDEF.account}/getedit`)
        .then(response => {
          if (response.data && response.data.success) {
            const model = response.data.result;
            this.model = model;
            
            //we must do this so that the value from the phone data is passed through the mask
            //otherwise it won't show a masked value correctly unless the user tries to edit the value first
            this.$nextTick(()=>{
              this.$refs.phoneInput.updateToCoreState();
            });

            this.selectedCountry = model.Country;
            this.selectedState = model.State;
            this.selectedCounty = model.County;

          } else {
            //todo: soft error
            console.log("Fail");
          }
        })
        .catch(err=>{
          //todo: hard error
          console.log(err);
        });
       
      });
    });
  },
  beforeUnmount() {
   
  },
  created(){
    this.uniqueId = getRandomId();
  }
};

</script>
